import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { toPersianNumber } from "@/hooks/useThousandsSeparator";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";

export interface SidebarItem {
  id: string;
  title: string;
  icon?: React.ReactNode;
  children?: { id: string; title: string; path: string }[];
  path: string;
}

export const DataSidebar: SidebarItem[] = [
  {
    id: "main-1",
    title: "صفحه اصلی",
    icon: <HomeOutlinedIcon />,
    path: "/",
  },
  {
    id: "recipient-information-1",
    title: "اطلاعات پذیرنده",
    icon: <AccountCircleOutlinedIcon />,
    path: "/profile",
  },
  {
    id: "wallet-1",
    title: `امور مالی  پولی پی`,
    icon: <AccountBalanceWalletOutlinedIcon />,
    children: [
      { id: "wallet-1-1", title: "افزایش موجودی نقدی", path: "/finance" },
      {
        id: "wallet-1-2",
        title: "برداشت از کیف پول",
        path: "/withdraw-wallet",
      },
      {
        id: "wallet-1-3",
        title: "گزارش ها و موجودی نقدی کیف پول",
        path: "/wallet-balance-reports",
      },
      {
        id: "wallet-1-4",
        title: "گزارش ها و موجودی اعتباری کیف پول",
        path: "/wallet-credit-balance-reports",
      },
      {
        id: "wallet-1-5",
        title: "گزارش ها مالی کلی پذیرنده",
        path: "/wallet-financial-reports",
      },
      {
        id: "wallet-1-6",
        title: "گزارش ها برداشت از کیف پول",
        path: "/wallet-withdrawal-reports",
      },
      {
        id: "wallet-1-7",
        title: "مدیریت کارت های شتابی",
        path: "/wallet-card-management",
      },
    ],
    path: "",
  },
  {
    id: "internal-1",
    title: "امور مالی اعتبارات داخلی",
    icon: <StorefrontOutlinedIcon />,
    children: [
      {
        id: "internal-1-1",
        title: "گزارش ها و موجودی هدیه داخلی",
        path: "/internal-reports-inventory",
      },
    ],
    path: "",
  },
  {
    id: "gold-1",
    title: "گزارش های طلا",
    icon: <EmojiEventsOutlinedIcon />,
    children: [
      {
        id: "gold-1-1",
        title: "تراکنش های طلا",
        path: "/Gold-reports",
      },
      // {
      //   id: "gold-1-2",
      //   title: "تراکنش های طلا داخلی",
      //   path: "/Gold-reports-internal",
      // },
      // {
      //   id: "gold-1-3",
      //   title: "تراکنش های طلا خارجی",
      //   path: "/Gold-reports-external",
      // },
    ],
    path: "",
  },
  {
    id: "customer-service",
    title: "خدمات مشتریان",
    icon: <PeopleAltOutlinedIcon />,
    children: [
      {
        id: "customer-service-1-1",
        title: "ثبت مشتری",
        path: "/customer-service",
      },
      {
        id: "customer-service-2-1",
        title: "ثبت سازمان",
        path: "/customer-organization",
      },
      {
        id: "customer-service-3-1",
        title: "سازمان های من",
        path: "/customer-my-organization",
      },
    ],
    path: "/customer-service",
  },
];
